// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-subtabs__container {
    margin-top: 3.6rem;
    width: 72rem;
    display: flex;
    gap: .3rem;
}

.contact-subtabs__container button {
    margin-right: 5px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.contact-subtabs__checked {
    color: rgb(255, 255, 0);
}

.contact-subtabs__container {
    display: flex;
    flex-wrap: nowrap;
    margin-right: 3rem;
    margin-bottom: 0.2rem;
}

.contact-subtabs__container span{
    margin-left: .5rem;
    margin-right: .5rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: medium;
    cursor: pointer;
    margin-bottom: -2px;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    white-space: nowrap;
}

.contact-subtabs__container span.checked{
    font-weight: bold;
    border-bottom: 2px solid #26a69a;
}`, "",{"version":3,"sources":["webpack://./src/app/contact/contact-main/contact-list/contact-item/contact-item-info/contact-subtabs/ContactSubtabs.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC","sourcesContent":[".contact-subtabs__container {\r\n    margin-top: 3.6rem;\r\n    width: 72rem;\r\n    display: flex;\r\n    gap: .3rem;\r\n}\r\n\r\n.contact-subtabs__container button {\r\n    margin-right: 5px;\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n}\r\n\r\n.contact-subtabs__checked {\r\n    color: rgb(255, 255, 0);\r\n}\r\n\r\n.contact-subtabs__container {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    margin-right: 3rem;\r\n    margin-bottom: 0.2rem;\r\n}\r\n\r\n.contact-subtabs__container span{\r\n    margin-left: .5rem;\r\n    margin-right: .5rem;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    font-size: medium;\r\n    cursor: pointer;\r\n    margin-bottom: -2px;\r\n    -moz-user-select: none;\r\n    -khtml-user-select: none;\r\n    user-select: none;\r\n    white-space: nowrap;\r\n}\r\n\r\n.contact-subtabs__container span.checked{\r\n    font-weight: bold;\r\n    border-bottom: 2px solid #26a69a;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
